export enum EstimatesRoles {
  DEFAULT_ITEMS_VIEWER = 'roles.estimatesDefaultItemsViewer',
  DEFAULT_ITEMS_MANAGER = 'roles.estimatesDefaultItemsManager',
  PREFERRED_PRODUCT_MANAGER = 'roles.preferredProductManager',
  CREATOR = 'roles.estimatesCreator',
  EDITOR = 'roles.estimatesEditor',
  ARCHIVER = 'roles.estimatesArchiver',
  PERSISTER_SENDER = 'roles.estimatesPersisterSender',
}
